<template>
  <base-dialog :value="isShown"
               :title="deleteTitle"
               :text="deleteDescription"
               :is-primary-button-busy="isBusyDeleting"
               @cancel="handleCancel"
  >
    <template #icon>
      <slot name="delete-item-icon" />
    </template>

    <template v-if="dialogType === 'prompt'" #prompt-input>
      <base-input v-model="inputValue"
                  :placeholder="inputPlaceholder"
                  :variant="'editor-soft'"
                  class="mt-2 w-full h-10"
      />
    </template>

    <template #confirm-button>
      <busy-button class="flex items-center justify-center w-full ml-4"
                   :id="BUSY_BUTTONS.ITEM_DELETE"
                   :is-loading="isBusyDeleting"
                   :is-disabled="isConfirmButtonDisabled"
                   variant="bordered-error"
                   @click="$emit('delete', item)"
      >
        <delete-icon class="h-5 w-5" />
        <span class="ml-1">{{ deleteConfirmText }}</span>
      </busy-button>
    </template>
  </base-dialog>
</template>

<script>
import BusyButton from '@/components/common/BusyButton'
import DeleteIcon from '@/assets/images/icons/DeleteIcon'
import busyButtonsModule from '@/store/modules/busy-buttons.module'
import { BUSY_BUTTONS } from '@/utils/busy-buttons.constants'

export default {
  name: 'DeleteDialog',

  components: {
    BusyButton,
    DeleteIcon
  },

  props: {
    isShown: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null
    },
    dialogType: {
      type: String,
      default: 'alert'
    },
    deleteTitle: {
      type: String,
      required: true
    },
    deleteDescription: {
      type: String,
      required: true
    },
    deleteConfirmText: {
      type: String,
      required: true
    },
    inputPlaceholder: {
      type: String,
      default: null
    },
    requiredPromptValue: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      BUSY_BUTTONS,
      inputValue: null
    }
  },

  computed: {
    isBusyDeleting() {
      return busyButtonsModule.isButtonBusy(BUSY_BUTTONS.ITEM_DELETE)
    },
    isConfirmButtonDisabled() {
      return this.dialogType === 'prompt' ? this.inputValue !== this.requiredPromptValue : false
    }
  },

  methods: {
    handleCancel() {
      this.inputValue = null
      this.$emit('cancel')
    }
  }
}
</script>
